<script>
import {onMount } from 'svelte';
import {supabase} from "./supabaseClient"
import router from 'page'
import {user} from "./sessionStore"
import boardTemplates from "./boardTemplates.js"
import UpgradeDialog from './UpgradeDialog.svelte';
import { fade } from 'svelte/transition';

import Speedometer from "svelte-speedometer"
import StandardHeader from "./StandardHeader.svelte"
import StandardFooter from "./StandardFooter.svelte"
import Editable from "./Editable.svelte"
import sentimentColourScale from "./sentimentColourScale"

import Icon from 'svelte-awesome';
import { faCaretDown, faEllipsisV, faPen, faTrash, faCopy} from '@fortawesome/free-solid-svg-icons';
import { MaterialApp, Card, Button, ListItem, Menu,List, Subheader, Overlay, Dialog, CardTitle, CardText, CardActions, Snackbar} from 'svelte-materialify';
import moment from 'moment';

var myBoards = [];
let displayAddBoardErrror = '';
let displayUpgradeButton = false;

let cardMenuClicked=false; 
let editBoardTitleID=''; 
let originalValue = '';

let boardChannels = [];
let showCopyLinkSnackbar = false;

onMount(async () => {
      document.title= "My Boards | MoodFirst"

  let { data: boards, error } = await supabase
  .from('boards')
  .select(`
    *,
    board_instances!BoardInstances_board_id_fkey (
      id, date, avg_sentiment_score,
      moods(id, mood, giphy_url, attendee_id)
    )
  `)
  .is('removed_at', null);

  if (error) {
    console.log(error)
  } else {
    myBoards = boards;

    //setup event monitoring
    let index = 0;
     boards.forEach((board) => {
      boardChannels[index] = supabase.channel(board.access_key);
      boardChannels[index].on('broadcast', { event: '*' }, (payload) => {
        console.log('boardChannel Event received')
        if (payload.event == 'moodUpdate') {
          // console.log('boardChannel event: moodUpdate')
          // console.log(payload);
          handleMoodUpdateEvent(payload);
        }
      })
      .subscribe()
      index++
     })
  }
 
   // Reduce Emoji size for Windows
  if (navigator.appVersion.indexOf("Win")!=-1) {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = '.mood-card-mood{font-size: 28px !important}';
    document.getElementsByTagName('head')[0].appendChild(style);
  }
  
})

function handleMoodUpdateEvent(eventData) {

  // Destructuring to extract relevant data from the event payload.
  const { moodData } = eventData.payload;
  const {
    _attendee_id,
    _board_id,
    _instance_id,
    _mood,
    _reason,
    _help_required,
    _instance_date,
    _giphy_url,
  } = moodData;

  // Update the moods array or a specific board instance based on the received data.
  // Assuming 'boards' is your array of board objects and 'moods' is an array you're updating.

  // Find the specific board using the provided _board_id.
  let board = myBoards.find(b => b.id === _board_id);

  if (board) {
    // Find the specific instance within the board's instances.
    // This assumes that 'instances' is an array within your board object.
    let instance = board.board_instances.find(i => i.id === _instance_id);

    if (instance) {
      // Create a new object representing the updated mood.
      const updatedMood = {
        attendee_id: _attendee_id, 
        mood: _mood, 
        reason: _reason,
        help_required: _help_required,
        instance_date: _instance_date,
        giphy_url: _giphy_url ? _giphy_url : '',
      };

      // Update moods array (remove existing mood for that attendee first.)
      instance.moods = instance.moods.filter(mood => mood.attendee_id !== _attendee_id);
      instance.moods.push(updatedMood); 

      myBoards = [...myBoards]; // Reassignment to trigger reactivity
 
      // Call function to udpate instance sentiment score from the database.
      setTimeout(() => {
          updateInstanceSentiment(instance);
        }, 1000); // Delay execution of the function by 3000 milliseconds (or 3 seconds)

    } else {
      console.error('Board instance not found.');
    }
  } else {
    console.error('Board not found.');
  }
}

const updateInstanceSentiment = async (instance) => {
  let { data: board_instances, error } = await supabase
    .from('board_instances')
    .select('avg_sentiment_score')
      .eq('id', instance.id)
  if (error) {
    console.log(error)
  } else {
     instance.avg_sentiment_score = board_instances[0].avg_sentiment_score;
     myBoards = [...myBoards];
  }
} 

async function copyBoardLink(boardAccessKey) {
  cardMenuClicked = true;
  setTimeout(() => cardMenuClicked = false, 100);
  let boardURL = window.location.protocol + '//' + window.location.host + '/Board?accessKey=' + boardAccessKey;
  // alert(boardURL); 
  try {
    // Use the Clipboard API to write text
    await navigator.clipboard.writeText(boardURL);
    showCopyLinkSnackbar = true;
  } catch (err) {
    // This can happen if the user denies clipboard permissions, or another error occurs
    console.error('Could not copy text to clipboard', err);
  }
}

const navBoard = async (accessKey) => {
  document.location.href='/Board?accessKey=' + accessKey
}

let newBoardTitle = '';
let template=boardTemplates[0];
let showUpgradeDialog = false;

const handleCreateBoardWithTemplate = async (selectedTemplate) => {
  template = selectedTemplate
}

const handleCreateBoard = async () => {
 
  // Check plan
  if (!user.plan) {
    if(myBoards.length >= 2) {
      displayAddBoardErrror='You need to upgrade to add more boards.😬'
      displayUpgradeButton = true
      return
  }
} else {
  if (myBoards.length >= user.plan.max_boards) {
    displayAddBoardErrror='You need to upgrade to add more boards.😬'
    displayUpgradeButton = true
    return
  }
}


  let questionText = ''
  switch (template.templateID) {
    case 'DEFAULT_TEMPLATE':
      questionText = 'What\'s your mood today?';
      break;
    case 'SPRINT_PLANNING':
      questionText = 'How do you feel about the Sprint Backlog?'
      break;
    case 'DAILY_STANDUP':
      questionText = 'How are you feeling about the Sprint?'
      break;
    case 'SPRINT_REVIEW':
      questionText = 'How do you feel about the output of the Sprint?';
      break;
    case 'SPRINT_RETRO':
      questionText = 'How do you feel the Sprint went?';
      break;
    default:
      questionText = 'What\'s your mood today?';
  }

  if (newBoardTitle == '') {
    displayAddBoardErrror = 'You need to add a name for your new board 🙂';
    return;
  }
  const prohibitedWords = ['call girls','escorts'];
  if (prohibitedWords.some(s => newBoardTitle.toLowerCase().includes(s))){
    displayAddBoardErrror = "Sorry, you can't use those words in the board title.";
    return;
  }

  let { data, error } = await supabase
    .rpc('create_board_set_owner', {
      _title: newBoardTitle,
      _question: questionText
    })

   if (error) console.error(error)
   else console.log(data)
    window.location.href = '/board?accessKey=' + data.access_key
}


const handleSaveBoardTitle = async (boardId) => {
  let editElement = document.getElementById('title-' + boardId)

  editElement.classList.remove('editing-element-my-boards');
  editElement.setAttribute('contenteditable',false);

  const { error} = await supabase
    .from('boards')
    .update({ title: editElement.innerText })
    .eq('id', boardId)
    if (error) console.error(error);
  editBoardTitleID='';
}

function handleEditBoard (boardId){
  cardMenuClicked = true;
  setTimeout(() => cardMenuClicked = false, 100);

  editBoardTitleID = boardId;

  // Add the edting class to the element being edited.
  let editElement = document.getElementById('title-' + boardId)
  originalValue = editElement.innerText;
  editElement.setAttribute('contenteditable',true);
  editElement.classList.add('editing-element-my-boards');
  editElement.focus();

   const range = document.createRange();
  // range.selectNodeContents(editableDiv);
  range.selectNodeContents(editElement);
  range.collapse(false); // false means collapse to end

  // Get the Selection object and add the Range
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);

}

function handleCancelEditTitle() {
  cardMenuClicked = true;
  setTimeout(() => cardMenuClicked = false, 100);

  let editElement = document.getElementById('title-' + editBoardTitleID)
  editElement.innerText =  originalValue;
  editElement.classList.remove('editing-element-my-boards');
  editElement.setAttribute('contenteditable',false);
  editBoardTitleID ='';
}

let removeBoardId = ''
let showConfirmRemoveBoard = false;
function confirmRemoveBoard(boardId) {
  cardMenuClicked = true;
  setTimeout(() => cardMenuClicked = false, 100);
  removeBoardId = boardId;
  showConfirmRemoveBoard = true;
}

function closeConfirmRemoveBoard() {
  removeBoardId = '';
  showConfirmRemoveBoard = false;
}

const handleRemoveBoard = async () => {
  const { data, error } = await supabase
    .from('boards')
    .update({ removed_at: new Date().toISOString() })
    .eq('id', removeBoardId);

  if (error) {
    console.error('Error removing board:', error);
  } 

   myBoards = myBoards.filter(board => board.id !== removeBoardId);


  removeBoardId = '';
  showConfirmRemoveBoard = false;
  }

function navigateToBoard(event, accessKey) {
  if(cardMenuClicked || editBoardTitleID !=''){
    return;
  }

  window.location.href = '/Board?accessKey=' + accessKey;
  }

function getSentimentColourCode (sentiment) {
    if (Number.parseFloat(sentiment)) {
      var sentimentFixed = Number.parseFloat(sentiment).toFixed(1)
      return sentimentColourScale.filter(a => a.sentiment == sentimentFixed)[0].colour_code
    } else {
      //return 'green'
      return sentimentColourScale.filter(a => a.sentiment == 0)[0].colour_code
  }
}



</script>
<div class="pageContainer min-h-screen flex flex-col">

  <StandardHeader />

  <div class="mainContentSection flex-grow">
    <MaterialApp>
      <div style="margin-top: 32px; display: flex;">

        <!-- Create new board Form -->
        <form on:submit|preventDefault|once={handleCreateBoard}>

          <div class="flex">
            <input
              type="text"
              placeholder="Team Name"
              bind:value={newBoardTitle}
              class="input input-bordered rounded-r-none w-64"
            />
            <button
              type="submit"
              class="btn btn-primary rounded-l-none"
              style="background-color: var(--aqua);"
            >
              Create a {template.templateName}
            </button>
    
          <!-- Templates drop down -->
            <Menu nudgeX="-115">
              <div slot="activator" style="margin-left: -22px">
              <button class="primary" on:click|preventDefault title="Templates" style="border-top:0px !important; border-bottom:0px !important; border-top-left-radius: 0px !important; border-bottom-left-radius: 0px !important;border-left: 0px !important;">
                <Icon data={faCaretDown} scale="1.0" />
              </button>
              </div>
              <List>
                <Subheader style="color: var(--blue); font-weight: bold; font-size: 16px; height: 20px !important">Standard Templates</Subheader>
                {#each boardTemplates.filter(e=> {return e.templateCategory =="STANDARD"}) as template}
                <ListItem on:click={(e) => {handleCreateBoardWithTemplate(template)}} style="background-color:white;color: var(--aqua); font-weight: bold;  width: 320px">
                  {template.templateName}
                  <span slot="subtitle">{template.templateDescription}</span>
                </ListItem>
                {/each}
                <Subheader style="color: var(--blue); font-weight: bold; font-size: 16px; max-height:60px !important">
                  Agile Templates
                  <span style=" font-weight: normal;display: flex">&nbsp; &nbsp;

                  <!-- Check Plan-->
                  {#if !user.plan || !user.plan.features.includes('AGILE_TEMPLATES')}
                    <button class="btn btn-primary rounded-l-none"
                    style="background-color: var(--aqua);margin-bottom: 0px !important" on:click|preventDefault={(e) => {showUpgradeDialog = true}}>
                    Upgrade Now
                    <span style="font-size:20px">&nbsp;🚀</span>

                    </button>
                  {/if}
                  </span>
                </Subheader>
                {#if user.plan && user.plan.features.includes('AGILE_TEMPLATES')}
                  {#each boardTemplates.filter(e=> {return e.templateCategory =="AGILE"}) as template}
                  <ListItem on:click={(e) => {handleCreateBoardWithTemplate(template)}} style="background-color:white;color: var(--aqua); font-weight: bold">
                    {template.templateName}
                    <div slot="subtitle" class="wordwrap">{template.templateDescription}</div>
                  </ListItem>
                  {/each}
                {:else}
                  {#each boardTemplates.filter(e=> {return e.templateCategory =="AGILE"}) as template}
                  <ListItem on:click={(e) => {handleCreateBoardWithTemplate(template)}} style="background-color:white;color: lightgrey; font-weight: bold" disabled="true">
                    {template.templateName}
                    <div slot="subtitle" class="wordwrap">
                      {template.templateDescription}
                    </div>
                  </ListItem>
                  {/each}
                {/if}
              </List>
            </Menu>
          <!-- {/if} -->

        </form>

      <!-- Form Error -->
         <span class="addBoardError" in:fade="{{ y: 200, duration: 1100 }}" hidden={displayAddBoardErrror==''}> {displayAddBoardErrror}</span>
         &nbsp;
        {#if displayUpgradeButton}
          <button 
            class="btn btn-primary rounded-l-none"
              style="background-color: var(--aqua);" on:click={(e) => {showUpgradeDialog=true}}
              >Upgrade now 
            </button>
        {/if}
      </div>
     
<!--       <div style="height:32px">
      </div> -->

      {#if myBoards && myBoards.length > 0}
        <div id="page-title">My Boards</div>
      {/if}

      <div style="display:flex; flex-direction: row;  flex-wrap: wrap;">

        {#each myBoards as board, index}
        {@const latestInstance = board.board_instances[board.board_instances.length - 1]}
        {@const instanceMoods = latestInstance ? latestInstance.moods.sort((a, b) => a.id - b.id): []}
        {@const flatMoods = instanceMoods.reduce((acc, moodObj) => {
            if (moodObj.mood.length === 0) {
                acc.push({
                    id: moodObj.id,
                    mood: null,
                    giphy_url: moodObj.giphy_url
                });
            } else {
                moodObj.mood.forEach(mood => {
                    acc.push({
                        id: moodObj.id,
                        mood: mood,
                        giphy_url: moodObj.giphy_url
                    });
                });
    }
        return acc.slice(-16) ;
    }, [])
      }
        <!-- <a href="/Board?accessKey={board.access_key}"> -->
        <div class="card-container" on:click={(e) => navigateToBoard(e,board.access_key)}>
          <Card  class="mood-board-card" >
            <!-- <div class="pl-4 pr-4 pt-3 board-card-layout"> -->
            <div class="board-card-layout">
           
            <!-- Title Container -->
            <div class="titleContainer"
            style="background-Color:{latestInstance && latestInstance.avg_sentiment_score ? getSentimentColourCode(latestInstance.avg_sentiment_score): getSentimentColourCode(0)};
            background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 4px, rgba(255, 255, 255, 1));"
            >

                <div class="boardTitle" id="title-{board.id}">{board.title}</div>
              
                <Menu closeOnClick nudgeX="-152" on:open={()=>{cardMenuClicked = true; setTimeout(() => cardMenuClicked = false, 100);}}>
                  <div slot="activator" style="padding:20px; margin: -20px; cursor: pointer !important" class="ellipsis-icon">
                    <Icon data={faEllipsisV} scale="1.0" class="ellipsis-icon" />
                  </div>  
                  
                  <List dense nav>
                                   
                    <ListItem id="copy-board-link" on:click={e => {copyBoardLink(board.access_key)}} >
                      <div class="board-menu-div">
                      <Icon data={faCopy} scale="1.14" style="color: var(--aqua) !important; margin-right: 8px" />
                      Share Board Link
                    </div>
                    </ListItem>

                    <ListItem id="rename-board-my-boards" on:click={e => {handleEditBoard(board.id)}} >
                      <div class="board-menu-div">
                      <Icon data={faPen} scale="1.14" style="color: var(--aqua) !important; margin-right: 8px" />
                      Rename Board
                    </div>
                    </ListItem>   


                    <ListItem on:click={e => {confirmRemoveBoard(board.id)}}>
                      <div class="board-menu-div">
                      <Icon data={faTrash} scale="1.14" style="color: red !important; margin-right: 8px" />
                      Remove Board
                      </div>
                    </ListItem>
                  </List>
                </Menu>
            </div>
          
            {#if editBoardTitleID == board.id}
              <div style="display: flex; justify-content: flex-end; margin-top: 4px">
                <Button class="primary small" on:click={ () => handleSaveBoardTitle(board.id)}>✓</Button>
                <Button class="secondary small" on:click={handleCancelEditTitle}>x</Button>
              </div>
            {/if}

          <!-- Mood Container -->
          <div class="mood-container wordwrap">
              {#if latestInstance && latestInstance.moods && latestInstance.moods.length > 0}
              {#each flatMoods as mood}
                {#if mood.giphy_url != ''}
                  <span class="mood-card-mood"><img class="giphy-img" src="{mood.giphy_url}" /></span>
                {:else}
                  {#if mood.mood && mood.mood.length > 0}              
                    <span class="mood-card-mood">{mood.mood}</span>
                  {/if}
                {/if}

               <!-- {JSON.stringify(mood, null, 2)}<br> -->
              {/each}

              {/if}
          </div>

          <!-- Footer Container -->
          <div class="footer-container">

              <!-- Last Updated -->
              <div class="boardLastUpdated">
                <span class="board-last-updated-icon">📆</span>
                {#if board.board_instances[0]}       
                  {moment(board.board_instances[board.board_instances.length - 1].date).isSame(moment(), 'day') ? 'Today' : moment(board.board_instances[board.board_instances.length - 1].date).fromNow()}
            
               {:else}
                  Not started yet
               {/if}
              </div>

            <div class="speedometer-wrapper">
             <Speedometer width={100} height={50} minValue={-0.52} maxValue={0.8}
            value={(latestInstance && latestInstance.avg_sentiment_score) ? latestInstance.avg_sentiment_score : 0.14} 
            needleColor="#255991" labelFontSize={0} ringWidth={12} needleTransition="easeElastic" needleTransitionDuration={6666}
            segments={11}
            segmentColors={['#DA1A0F', '#E85E37', '#EA683C','#F29053','#ECAB60','#439D37','#87B824','#AACD6F','#E8E88F','#FCF275','#FFF60D']} needleHeightRatio={0.55}/>
          </div>
            </div>
            </div>
          </Card>
        </div>
          <!-- </a> -->
        {/each}
      </div>

    </MaterialApp>
  </div>

   <!-- Confirm Remove Board Dialog -->
    <Dialog persistent bind:active={showConfirmRemoveBoard}>
     
      <Card style="background-color: white">
        
          <CardTitle class="dialogTitle">Remove this Board?</CardTitle>
          <CardText>
            Are you sure you want to remove this board along with all the moods?
          </CardText>
          <CardActions>
            <div style="margin-left:auto">
            <Button on:click={closeConfirmRemoveBoard} text class="secondary">Cancel</Button>&nbsp;
            <Button id="confirm-remove-board-button" on:click={handleRemoveBoard} class="buttonDanger" style="float:right"> Yes - Remove</Button>
            </div>
          </CardActions>
      </Card>
    </Dialog>

    <!-- Snackbar: Confirm copied to clipboard -->
  <Snackbar class="justify-space-between" bind:active={showCopyLinkSnackbar} center timeout={2500}>
        <div style="text-align: center;width: 100%">Copied board link to clipboard</div>
  </Snackbar>

  <!-- <UpgradeOptions bind:showUpgradeDialog={showUpgradeDialog} /> -->
  <UpgradeDialog
  visible={showUpgradeDialog}
  onClose={() => showUpgradeDialog = false}
/>
  <StandardFooter />
</div>
<style>
  .pageContainer{min-height: 100vh;  position: relative;}
  .mainContentSection {margin-left: 6%; margin-right: 6%; padding-bottom:90px}

  #page-title {color: var(--blue); font-weight: bold; font-size:22px; margin-bottom: 4px; margin-top: 10px}
  .card-container {cursor: pointer}

  /*  
    Mood Board Card Layout
    mood-bard-card uses display: flex. board-card-layout uses flex-grow to fill the available space.
    footer-conainer uses margin-top: auto so it's always at the bototm.
    Max-height for mood-container set to 114px = 3 x line height of 38px
  */
  :global(.mood-board-card) {max-width:343px !important;min-width:343px !important; margin-right: 34px; margin-bottom: 28px; min-height:232px; display: flex !important;
    box-shadow: 0 6px 8px 0 #0003;
    border: #dbdbdb solid 0.6px;
    border-radius: 6px !important;
    overflow: hidden;
  }
  .board-card-layout {flex-grow:1 !important; display: flex !important; flex-direction: column;}
  .titleContainer {display: flex; justify-content: space-between;align-items: flex-start; padding-left: 16px; padding-right: 16px; padding-top: 12px; min-height: 52px;}
  .mood-container{display: flex; flex-wrap: wrap;  line-height: 38px; margin-top: 6px; position: relative; bottom: -4px; max-height: 114px; margin-right: 16px; margin-left: 16px;}
  .footer-container {display: flex; Xbackground-color: #eeeee4; margin-top: auto; margin-right: 16px; margin-left: 16px;}

  :global(.editing-element-my-boards){
    margin: 0 !important;
    padding-right: 38px !important;
    outline: none !important;
    border: 1px solid var(--blue);
    border-radius: 4px;
    padding-left: 6px;
    padding-right: 6px;
    cursor: text !important;
  }

  .ellipsis-icon{
/*    color: #b0b0b0;*/
    color: var(--blue);
    cursor: hand;
    margin-left: 10px; /* Optional: Add some space between the title and the icon */
  }
  .ellipsis-icon:hover {
    color: var(--aqua);
  }
  .board-menu-div {display:flex; align-items: center; color: var(--blue); font-size: 16px; cursor: pointer;}

  .boardTitle {
  color: var(--blue); font-weight:bold; font-size:20px; line-height: 22px;
  flex: 1; /* Allow the title to take up the available space */
  /*  max-width: calc(100% - 12px); */
}
  .boardLastUpdated {font-size:16px; color: var(--aqua); font-weight: bold; margin-top: auto}
  .board-last-updated-icon {font-size: 20px; margin-right: 2px}
  .mood-card-mood {margin-right: 4px;font-size: 34px;}
  .giphy-img {height: 38px; width: auto; border-radius: 4px;}
  .addBoardError{color: red; vertical-align: top; font-size: 20px;  margin-left: 12px}

  .speedometer-wrapper{margin-left: auto}
  .wordwrap {
   white-space: pre-wrap;      /* CSS3 */
   white-space: -moz-pre-wrap; /* Firefox */
   white-space: -pre-wrap;     /* Opera <7 */
   white-space: -o-pre-wrap;   /* Opera 7 */
   word-wrap: break-word;      /* IE */
}
</style>
